import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const headingDefinition: ComponentDefinition = {
  id: 'heading-experience',
  name: 'Heading',
  category: 'Basic',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/heading.svg',
  variables: {
    content: {
      displayName: 'Content',
      type: 'Text',
      defaultValue: 'Heading text',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    tag: {
      displayName: 'Heading type',
      type: 'Text',
      defaultValue: 'h2',
      group: 'style',
      validations: {
        in: [
          { value: 'h1', displayName: 'H1' },
          { value: 'h2', displayName: 'H2' },
          { value: 'h3', displayName: 'H3' },
          { value: 'h4', displayName: 'H4' },
          { value: 'h5', displayName: 'H5' },
          { value: 'h6', displayName: 'H6' },
          { value: 'p', displayName: 'p' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    tagClass: {
      displayName: 'Heading CSS class',
      type: 'Text',
      defaultValue: 'none',
      group: 'style',
      validations: {
        in: [
          { value: '', displayName: 'none (the Tag determines the font size)' },
          { value: 'h1', displayName: 'H1' },
          { value: 'h2', displayName: 'H2' },
          { value: 'h3', displayName: 'H3' },
          { value: 'h4', displayName: 'H4' },
          { value: 'h5', displayName: 'H5' },
          { value: 'h6', displayName: 'H6' },
          { value: 'p', displayName: 'p' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    // width: {
    //   displayName: 'Width',
    //   type: 'Text',
    //   defaultValue: 'fixed',
    //   group: 'style',
    //   validations: {
    //     in: [
    //       { value: 'fixed', displayName: 'Fixed' },
    //       { value: 'fit', displayName: 'Fit' },
    //     ],
    //     bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
    //   },
    // },
    // widthUnit: {
    //   displayName: 'Fixed width unit',
    //   type: 'Text',
    //   defaultValue: '%',
    //   group: 'style',
    //   validations: {
    //     in: [
    //       { value: '%', displayName: '%' },
    //       { value: 'px', displayName: 'px' },
    //       { value: 'rem', displayName: 'rem' },
    //     ],
    //     bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
    //   },
    // },
    // widthValue: {
    //   displayName: 'Width value',
    //   type: 'Number',
    //   group: 'style',
    //   validations: {
    //     bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
    //   },
    // },
    paddingX: {
      displayName: 'Padding X',
      type: 'Number',
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    paddingY: {
      displayName: 'Padding Y',
      type: 'Number',
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    fontSize: {
      displayName: 'Font size overwrite (leave blank to use desing system)',
      type: 'Number',
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    color: {
      displayName: 'Color',
      type: 'Text',
      defaultValue: 'text-text-dark-purple',
      group: 'style',
      validations: {
        in: [
          { value: 'text-text-dark-purple', displayName: 'Purple' },
          { value: 'text-text-white', displayName: 'White' },
          { value: 'text-text-white-on-dark', displayName: 'White on dark' },
          { value: 'text-text-grey', displayName: 'Grey' },
          { value: 'text-text-pink-accent', displayName: 'Pink' },
          { value: 'text-text-link-blue', displayName: 'Link blue' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    textAlign: {
      displayName: 'Text align',
      type: 'Text',
      defaultValue: 'text-center',
      group: 'style',
      validations: {
        in: [
          { value: 'text-left', displayName: 'Left' },
          { value: 'text-center', displayName: 'Center' },
          { value: 'text-right', displayName: 'Right' },
        ],
      },
    },
  },
} as const;
